import { SupportedDailyWeeklyRentalTypes } from 'enums/supportedRentalTypes';
import { dateService } from 'services/DateService';
import { VehicleBasedDailyWeeklyDemandState } from 'types/demand.type';
import { DailyWeeklyRentalInfo } from 'types/vehicle.type';

export function usePriceWidgetDWAvailableDays(
  rentalInfo: DailyWeeklyRentalInfo,
  state: VehicleBasedDailyWeeklyDemandState
) {
  const dayjs = dateService.getDayjs();
  const disableDatesBeforeToday = (date: Date): boolean => {
    const today = dayjs().toDate();
    const todayCheckIn = dayjs(today)
      .startOf('day')
      .hour(rentalInfo.checkInHour)
      .toDate();
    const isSameDate = dateService.isSameDate(todayCheckIn, date);
    return (
      date.getTime() < today.getTime() ||
      (isSameDate && date.getTime() > todayCheckIn.getTime())
    );
  };

  const getDisabledDays = (date: Date): boolean => {
    if (
      !rentalInfo.supportedRentalTypes.includes(
        SupportedDailyWeeklyRentalTypes.DAILY
      ) &&
      state.demandVariant === SupportedDailyWeeklyRentalTypes.WEEKLY
    ) {
      // sunday offset
      return (
        (date.getDay() - 1 + 7) % 7 !== rentalInfo.checkInDay ||
        disableDatesBeforeToday(date)
      );
    }
    return disableDatesBeforeToday(date);
  };

  return {
    getDisabledDays,
    disableDatesBeforeToday,
  };
}
